module.exports = __webpack_public_path__ + "img/nyhead.47c19ee7.png";